// extracted by mini-css-extract-plugin
module.exports = {"deal_status_card_group":"DealStatus_deal_status_card_group__1H5hn","card_title":"DealStatus_card_title__1n_nc"};